import { Chip } from "@mui/material";
import { Localized } from "@fluent/react"; // jeśli używasz fluent-react do lokalizacji
import { DocumentTeamMemberRole } from "../teamMemberApi";


interface TeamMemberRoleChipProps {
    role: DocumentTeamMemberRole | undefined;
}

const roleColors: Record<DocumentTeamMemberRole, "default" | "primary" | "secondary" | "success" | "info" | "warning" | "error"> = {
    C_CLOSED: "info",
    C: "info",
    E: "info",
    R: "warning",
    A: "error",
    AR: "error",
    V: "default",
    EXT_R: "secondary",
    P: "primary",
};

export function TeamMemberRoleChip({ role }: TeamMemberRoleChipProps) {
    if (!role) return null;

    let label: React.ReactNode;
    switch (role) {
        case "C_CLOSED":
            label = (
                <Localized id="urs-role-creator-closed">
                    <span>_Wcześniejszy autor</span>
                </Localized>
            );
            break;
        case "C":
            label = (
                <Localized id="urs-role-creator">
                    <span>_Author</span>
                </Localized>
            );
            break;
        case "E":
            label = (
                <Localized id="urs-role-editor">
                    <span>_Edytor</span>
                </Localized>
            );
            break;
        case "R":
            label = (
                <Localized id="urs-role-reviever">
                    <span>_Opiniujący</span>
                </Localized>
            );
            break;
        case "A":
            label = (
                <Localized id="urs-role-approver">
                    <span>_Zatwierdzający</span>
                </Localized>
            );
            break;
        case "AR":
            label = (
                <Localized id="urs-role-reviever-and-approver">
                    <span>_Opiniujący + Zatwierdzający</span>
                </Localized>
            );
            break;
        case "V":
            label = (
                <Localized id="urs-role-viewer">
                    <span>_Obserwator</span>
                </Localized>
            );
            break;
        case "EXT_R":
            label = (
                <Localized id="urs-role-external-reviever">
                    <span>_Zewnętrzny opiniujący</span>
                </Localized>
            );
            break;
        case "P":
            label = (
                <Localized id="urs-role-publisher">
                    <span>_Publisher</span>
                </Localized>
            );
            break;
        default:
            return null;
    }

    return (
        <Chip
            label={label}
            color={roleColors[role] || "default"}
            size="small"
            variant="outlined"
        />
    );
}
